// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"v2-z","disabled":"w2-z","seeAllAnswers":"x2-z"};